import React, { useCallback, useMemo } from 'react'
import intl from 'react-intl-universal'
import RecomProductCard from './RecomProductCard'
import RestaurantCard from './RestaurantCard'
import SpaCard from './SpaCard'
import ProductCard from './ProductCard'
import MultiStoreProductCard from './ProductCard/MultiStoreProductCard'
import { formatJSON } from '../../utils'

// 卡片类型配置
const CARD_CONFIG = {
  1: {
    component: RecomProductCard,
    props: (stores) => ({ stores: stores.filter(item => item.products.length > 0) })
  },
  3: {
    component: SpaCard,
    props: (stores, areaId) => ({
      title: `${intl.get('equity_spa').d('Spa')}`,
      list: stores,
      areaId
    })
  },
  7: {
    component: RestaurantCard,
    props: (stores, areaId) => ({
      title: intl.get('restaurant').d('餐厅'),
      list: stores,
      areaId
    })
  },
  9: {
    component: RestaurantCard,
    props: (stores, areaId) => ({
      title: intl.get('restaurant').d('餐厅'),
      list: stores,
      areaId
    })
  },
  63: {
    component: RestaurantCard,
    props: (stores, areaId) => ({
      title: intl.get('restaurant').d('餐厅'),
      list: stores,
      areaId
    })
  },
  10: {
    component: MultiStoreProductCard,
    props: (stores, areaId) => ({
      title: intl.get('t_activity').d('Activities'),
      list: stores,
      areaId,
      from: 'activity',
      viewAll: true
    })
    // props: (stores, areaId) => {
    //   const actStore = stores.find(item => item.type === 10 && item.products.length > 0)
    //   return actStore ? {
    //     title: 'Activities',
    //     list: actStore.products,
    //     storeInfo: actStore,
    //     viewAll: true,
    //     areaId,
    //     from: 'activity'
    //   } : null
    // }
  },
  11: {
    component: ProductCard,
    props: (stores, areaId) => {
      const tourStore = stores.find(item => item.type === 11 && item.products.length > 0)
      return tourStore ? {
        title: 'Tour',
        list: tourStore.products,
        storeInfo: tourStore,
        from: 'tour',
        viewAll: true,
        areaId
      } : null
    }
  },
  14: {
    component: ProductCard,
    props: (stores, areaId) => {
      const souvenirStore = stores.find(item => item.type === 14 && item.products.length > 0)
      return souvenirStore ? {
        title: 'Souvenir',
        list: souvenirStore.products,
        storeInfo: souvenirStore,
        from: 'souvenir',
        viewAll: true,
        areaId
      } : null
    }
  },
  15: {
    component: ProductCard,
    props: (stores, areaId) => {
      const voucherStore = stores.find(item => item.type === 15 && item.products.length > 0)
      return voucherStore ? {
        title: intl.get('t_voucher').d('Voucher'),
        list: voucherStore.products,
        storeInfo: voucherStore,
        from: 'voucher',
        viewAll: true,
        areaId
      } : null
    }
  }
}

export default function RelateStoreCard({ storeInfo, areaid }) {
  // 处理关联商店信息
  const relateStoresInfo = useMemo(() => {
    const { extendColumn, stores } = storeInfo

    const extendObj = formatJSON(extendColumn) || {}
    let relateStoresInfoObj = extendObj.relateStoresInfo

    if (!relateStoresInfoObj) {
      return {}
    }

    const storeKeys = Object.keys(relateStoresInfoObj)
    //判断storeKeys是否包含7和9时,将7和9合并成63
    // const hasBoth7And9 = storeKeys.includes('7') && storeKeys.includes('9')
    // if (hasBoth7And9) {
    //   const resObj = relateStoresInfoObj[7]
    //   const barObj = relateStoresInfoObj[9]
    //   const minSort = Math.min(resObj.sort, barObj.sort)
    //   relateStoresInfoObj[63] = { sort: minSort, stores: [...resObj.stores, ...barObj.stores] }
    //   delete relateStoresInfoObj[7]
    //   delete relateStoresInfoObj[9]
    // }

    // 判断storeKeys是否包含7和9时,将7和9合并成63
    if (storeKeys.includes('7') && storeKeys.includes('9')) {
      const { 7: resObj, 9: barObj, ...rest } = relateStoresInfoObj
      relateStoresInfoObj = {
        ...rest,
        63: {
          sort: Math.min(resObj.sort, barObj.sort),
          stores: [...resObj.stores, ...barObj.stores]
        }
      }
    }
    // console.log(storeKeys)

    // 过滤并排序关联商店信息
    const filteredAndSorted = Object.entries(relateStoresInfoObj)
      .map(([key, value]) => {
        // 过滤掉 show 为 false 的商店
        const filteredStores = value.stores
          .filter(store => store.show).sort((a, b) => (b.sort || 0) - (a.sort || 0))
          .map(store => stores.find(s => s.storeId === store.id))
          .filter(Boolean)

        return filteredStores.length > 0
          ? [key, { ...value, stores: filteredStores }]
          : null
      })
      .filter(Boolean)
    // .sort(([, a], [, b]) => (b.sort || 0) - (a.sort || 0))

    // 创建排序后的对象
    const result = {}
    filteredAndSorted.forEach(([key, value]) => {
      result[key] = value
    })

    return result
  }, [storeInfo])

  // 渲染单个卡片
  const renderCard = useCallback((key, value) => {
    const { stores } = value

    if (stores.length === 0) {
      return null
    }

    const config = CARD_CONFIG[key]
    if (!config) {
      return null
    }

    const { component: Component, props: getProps } = config
    const props = getProps(stores, areaid)

    if (!props) {
      return null
    }

    return (
      <div className='mt15'>
        <Component {...props} />
      </div>
    )
  }, [areaid])

  const nObjEntries = Object.entries(relateStoresInfo).sort(([, a], [, b]) => (b.sort || 0) - (a.sort || 0))

  return (
    <div className='p10' style={{ padding: '0 15px 10px 15px' }}>
      {nObjEntries.map(([key, value]) => (
        <div key={key}>
          {renderCard(parseInt(key), value)}
        </div>
      ))}
    </div>
  )
}
